export default [
	{
		modulo: 27,
		privilegio: 203,
		routerName: 'relatorio-aviacao-civil',
		routerPath: '/seguranca-operacional/relatorio-aviacao-civil',
		componentName: 'RelatorioAviacaoCivil',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-aviacao-civil/main'
	},
	{
		modulo: 27,
		privilegio: 203,
		routerName: 'relatorio-aviacao-civil-cadastro',
		routerPath: '/seguranca-operacional/relatorio-aviacao-civil/cadastro',
		componentName: 'RelatorioAviacaoCivilCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-aviacao-civil/cadastro'
	},
	{
		modulo: 27,
		privilegio: 203,
		routerName: 'relatorio-aviacao-civil-visualizar',
		routerPath: '/seguranca-operacional/relatorio-aviacao-civil/visualizar/:id',
		props: true,
		componentName: 'RelatorioAviacaoCivilVisualizar',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-aviacao-civil/visualizacao'
	},
	{
		modulo: 27,
		privilegio: 203,
		routerName: 'relatorio-aviacao-civil-parecer',
		routerPath: '/seguranca-operacional/relatorio-aviacao-civil/parecer/:id',
		props: true,
		componentName: 'RelatorioAviacaoCivilParecer',
		componentPath:
			'modules/layout/seguranca-operacional/components/pareceres/main'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'relatorio-gerenciamento-risco',
		routerPath: '/seguranca-operacional/relatorio-gerenciamento-risco',
		componentName: 'RelatorioGerenciamentoRisco',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-gerenciamento-risco/main'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'relatorio-gerenciamento-risco-cadastro',
		routerPath: '/seguranca-operacional/relatorio-gerenciamento-risco/cadastro',
		componentName: 'RelatorioGerenciamentoRiscoCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-gerenciamento-risco/cadastro'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'relatorio-gerenciamento-risco-visualizar',
		routerPath:
			'/seguranca-operacional/relatorio-gerenciamento-risco/visualizar/:id',
		props: true,
		componentName: 'RelatorioGerenciamentoRiscoVisualizar',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-gerenciamento-risco/visualizacao'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'relatorio-gerenciamento-risco-parecer',
		routerPath:
			'/seguranca-operacional/relatorio-gerenciamento-risco/parecer/:id',
		props: true,
		componentName: 'RelatorioGerenciamentoRiscoParecer',
		componentPath:
			'modules/layout/seguranca-operacional/components/pareceres/main'
	},
	//

	{
		modulo: 27,
		privilegio: 202,
		routerName: 'evento-seguranca-operacional',
		routerPath: '/seguranca-operacional/gerenciamento-de-risco',
		componentName: 'EventoSegurancaOperacional',
		componentPath:
			'modules/layout/seguranca-operacional/evento-seguranca-operacional/main'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'evento-seguranca-operacional-cadastro',
		routerPath: '/seguranca-operacional/gerenciamento-de-risco/cadastro',
		componentName: 'EventoSegurancaOperacionalCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/evento-seguranca-operacional/cadastro'
	},
	{
		modulo: 27,
		privilegio: 202,
		props: true,
		routerName: 'evento-seguranca-operacional-visualizar',
		routerPath: '/seguranca-operacionalgerenciamento-de-risco/visualizar/:id',
		componentName: 'EventoSegurancaOperacionalVisualizar',
		componentPath:
			'modules/layout/seguranca-operacional/evento-seguranca-operacional/visualizacao'
	},
	{
		modulo: 27,
		privilegio: 202,
		props: true,
		routerName: 'evento-seguranca-operacional-editar',
		routerPath: '/seguranca-operacional/gerenciamento-de-risco/editar/:id',
		componentName: 'EventoSegurancaOperacionalCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/evento-seguranca-operacional/cadastro'
	},
	//
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia',
		routerPath: '/seguranca-operacional/relatorio-inicial-resposta-emergencia',
		componentName: 'RelatorioInicialRespostaEmergencia',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-inicial-resposta-emergencia/main'
	},
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia-cadastro',
		routerPath:
			'/seguranca-operacional/relatorio-inicial-resposta-emergencia/cadastro',
		componentName: 'RelatorioInicialRespostaEmergenciaCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-inicial-resposta-emergencia/cadastro'
	},
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia-visualizar',
		routerPath:
			'/seguranca-operacional/relatorio-inicial-resposta-emergencia/visualizar/:id',
		props: true,
		componentName: 'RelatorioInicialRespostaEmergenciaVisualizar',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-inicial-resposta-emergencia/visualizacao'
	},
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia-parecer',
		routerPath:
			'/seguranca-operacional/relatorio-inicial-resposta-emergencia/parecer/:id',
		props: true,
		componentName: 'RelatorioInicialRespostaEmergenciaParecer',
		componentPath:
			'modules/layout/seguranca-operacional/components/pareceres/main'
	},
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia-editar',
		routerPath:
			'/seguranca-operacional/relatorio-inicial-resposta-emergencia/editar/:id',
		props: true,
		componentName: 'RelatorioInicialRespostaEmergenciaCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-inicial-resposta-emergencia/cadastro'
	},
	{
		modulo: 27,
		privilegio: 39,
		routerName: 'relatorio-prevencao',
		routerPath: '/seguranca-operacional/relatorio-prevencao',
		componentName: 'RelatorioPrevencao',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-prevencao/main'
	},
	{
		modulo: 27,
		privilegio: 39,
		routerName: 'relatorio-prevencao-cadastro',
		routerPath: '/seguranca-operacional/relatorio-prevencao/cadastro',
		componentName: 'RelatorioPrevencaoCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-prevencao/cadastro'
	},
	{
		modulo: 27,
		privilegio: 39,
		props: true,
		routerName: 'relatorio-prevencao-editar',
		routerPath: '/seguranca-operacional/relatorio-prevencao/editar/:id',
		componentName: 'RelatorioPrevencaoCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-prevencao/cadastro'
	},
	{
		modulo: 27,
		privilegio: 39,
		routerName: 'relatorio-prevencao-visualizar',
		routerPath: '/seguranca-operacional/relatorio-prevencao/visualizar/:id',
		props: true,
		componentName: 'RelatorioPrevencaoVisualizar',
		componentPath:
			'modules/layout/seguranca-operacional/relatorio-prevencao/visualizacao'
	},
	{
		modulo: 27,
		privilegio: 39,
		routerName: 'relatorio-prevencao-parecer',
		routerPath: '/seguranca-operacional/relatorio-prevencao/parecer/:id',
		props: true,
		componentName: 'RelatorioPrevencaoParecer',
		componentPath:
			'modules/layout/seguranca-operacional/components/pareceres/main'
	},
	{
		modulo: 27,
		privilegio: 243,
		routerName: 'recomendacoes',
		routerPath: '/seguranca-operacional/recomendacoes',
		componentName: 'Recomendacoes',
		componentPath: 'modules/layout/seguranca-operacional/recomendacoes/main'
	},
	{
		modulo: 27,
		privilegio: 243,
		routerName: 'recomendacoes-cadastro',
		routerPath: '/seguranca-operacional/recomendacoes/cadastro',
		componentName: 'RecomendacoesCadastro',
		componentPath: 'modules/layout/seguranca-operacional/recomendacoes/cadastro'
	},
	{
		modulo: 27,
		privilegio: 243,
		routerName: 'recomendacoes-editar',
		routerPath: '/seguranca-operacional/recomendacoes/editar/:id',
		props: true,
		componentName: 'RecomendacoesCadastro',
		componentPath: 'modules/layout/seguranca-operacional/recomendacoes/cadastro'
	},
	{
		modulo: 27,
		privilegio: 243,
		routerName: 'recomendacoes-visualizar',
		routerPath: '/seguranca-operacional/recomendacoes/visualizar/:id',
		props: true,
		componentName: 'RecomendacoesVisualizar',
		componentPath: 'modules/layout/seguranca-operacional/recomendacoes/print'
	},
	{
		modulo: 27,
		privilegio: 272,
		routerName: 'recomendacoes-gerenciamento-de-risco',
		routerPath: '/seguranca-operacional/recomendacoes-gerenciamento-de-risco',
		props: true,
		componentName: 'RecomendacoesGerenciamentoDeRisco',
		componentPath:
			'modules/layout/seguranca-operacional/recomendacoes-gerenciamento-de-risco/main'
	},
	{
		modulo: 27,
		privilegio: 272,
		routerName: 'recomendacoes-gerenciamento-de-risco-editar',
		routerPath:
			'/seguranca-operacional/recomendacoes-gerenciamento-de-risco/editar/:id',
		props: true,
		componentName: 'RecomendacoesGerenciamentoDeRiscoEditar',
		componentPath:
			'modules/layout/seguranca-operacional/recomendacoes-gerenciamento-de-risco/cadastro'
	},
	{
		modulo: 27,
		privilegio: 375,
		routerName: 'reporte-fadiga',
		routerPath: '/seguranca-operacional/reporte-fadiga',
		props: true,
		componentName: 'RecomendacoesGerenciamentoDeRisco',
		componentPath: 'modules/layout/seguranca-operacional/reporte-fadiga/main'
	},
	{
		modulo: 27,
		privilegio: 375,
		routerName: 'reporte-fadiga-cadastro',
		routerPath: '/seguranca-operacional/reporte-fadiga/cadastro',
		props: true,
		componentName: 'ReporteFadigaCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/reporte-fadiga/cadastro'
	},
	{
		modulo: 27,
		privilegio: 375,
		routerName: 'reporte-fadiga-cadastro-editar',
		routerPath: '/seguranca-operacional/reporte-fadiga/editar/:id',
		props: true,
		componentName: 'ReporteFadigaCadastro',
		componentPath:
			'modules/layout/seguranca-operacional/reporte-fadiga/cadastro'
	},
	{
		modulo: 27,
		privilegio: 380,
		routerName: 'reporte-fadiga-modulo',
		routerPath: '/seguranca-operacional/reporte-fadiga-modulo',
		props: true,
		componentName: 'ReporteFadigaModulo',
		componentPath:
			'modules/layout/seguranca-operacional/reporte-fadiga-modulo/main'
	},
	{
		modulo: 27,
		privilegio: 380,
		routerName: 'reporte-fadiga-modulo-responder',
		routerPath: '/seguranca-operacional/reporte-fadiga-modulo/responder',
		props: true,
		componentName: 'ReporteFadigaResponder',
		componentPath:
			'modules/layout/seguranca-operacional/reporte-fadiga-modulo/responder'
	},
	{
		modulo: 27,
		privilegio: 380,
		routerName: 'reporte-fadiga-modulo-responder-visualizar',
		routerPath: '/seguranca-operacional/reporte-fadiga-modulo/responder/:id',
		props: true,
		componentName: 'ReporteFadigaResponder',
		componentPath:
			'modules/layout/seguranca-operacional/reporte-fadiga-modulo/responder'
	},
	{
		modulo: 27,
		privilegio: 414,
		routerName: 'cadastro-de-fase-voo',
		routerPath: '/seguranca-operacional/fase-de-voo',
		props: false,
		componentName: 'FaseVoo',
		componentPath: 'modules/layout/seguranca-operacional/fase-voo/main'
	}
]
